// import { toLower } from "lodash";
import SectionWrapper from "components/common/section/SectionWrapper/SectionWrapper";
import DetailsHeader from "components/common/Details/DetailsHeader/DetailsHeader";
import { ReactComponent as LinkIcon } from "assets/images/icons/link.svg";
import getTabRoutes from "../../helpers/tabs";
import { useHistory, useParams } from "react-router-dom";
import DetailSection from "./DetailSection";
import { cardResponse } from "../../helpers/data";
import CardInfoTable from "./CardInfoTable";
import SideTabs from "utils/SideTabs/SideTabs";

function WalletCard() {
	const history = useHistory();
	const { id } = useParams();
	return (
		<SectionWrapper
			cls="pb-0"
			containerCls="d-flex flex-wrap"
			routeName={
				<DetailsHeader
					detailID={id}
					icon={<LinkIcon className="me-3" />}
					IDName="Wallet Id"
					returnAction={() => history.push("/banking/wallets")}
					tabName="Banking Wallets"
				/>
			}
			tabs={getTabRoutes(id)}
			navTabChildren={
				<div className="d-flex">
					<button className="btn btn--sm btn--secondary--bordered me-4"></button>
					<button className="btn btn--sm btn--secondary--bordered me-4"></button>
				</div>
			}
		>
			<SideTabs
				tabComponent={[
					{
						name: "Naira Card - Virtual",
						id: "Naira Card-Virtual",
						Comp: (
							<>
								<DetailSection res={cardResponse} />
								<div className="border-top">
									<CardInfoTable />
								</div>
							</>
						),
					},
					{
						name: "Naira Card-Physical",
						id: "Naira Card-Physical",
						Comp: <h4>Not Available</h4>,
					},
					{
						name: "USD Card-Virtual",
						id: "USD Card-Virtual",
						Comp: <h4>Not Available</h4>,
					},
				]}
			/>
		</SectionWrapper>
	);
}

export default WalletCard;
